<template>
  <div>
    <div style="background:#fff;">
      <el-row>
        <el-col style="margin:10px;">
          <img src="@/assets/beadhouse/juxing.png" style="vertical-align:middle" />
          <span style="vertical-align:middle;font-size:16px;margin-left:10px">入院办理流程</span>
        </el-col>
        <el-col style="margin-top:20px;margin-bottom:20px">
            <el-steps :active="active+1"  class="step" space="32%" style="margin-left:12%">
              <el-step title="基本信息登记" icon="el-icon-edit"></el-step>
              <el-step title="收费项目选择" icon="el-icon-suitcase"></el-step>
              <el-step title="缴费信息录入" icon="el-icon-printer"></el-step>
            
            </el-steps>
        </el-col>

      </el-row>
      <el-row>
        <keep-alive>
          <router-view class="child"></router-view>
        </keep-alive>
      </el-row>
    </div>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab

export default {
  name: "OlderDetailAdd",
  data() {
    return {
      active:0,//当前子页面
    };
  },
  methods: {

    
    showChildPage(){
      if (this.active == 0) {
        this.$router.push({ path: "/OlderDetailAddBase"});
      }else if(this.active == 1){
        this.$router.push({ path: "/OlderDetailFeeChoose"});
      }else{
        this.$router.push({ path: "/OlderDetailFeeEnter"});
      }
    },
    getMsg(msg){
      console.log(msg);
      if(msg == 'next'){
        this.active = this.active + 1;
        this.showChildPage();
      }else if(msg == 'last'){
        this.active = this.active - 1;
        this.showChildPage();
      }else {
      }
    }

  },
  //采用keep-alive后进入页面执行的生命周期
  activated (){
    this.showChildPage();
  },
  created(){
    this.hospitalType=sessionStorage.getItem('hospitalType');//获取hospitalType
  },
  mounted() {
    this.showChildPage();
    bus.$on("admissiondetail", msg => {
      this.getMsg(msg);
    });
  },
  beforeDestroy () {
    //最后不要忘了删除传输事件
    bus.$off('admissiondetail')
  },
};
</script>
<style scoped>
  .child ::v-deep .el-main{
    padding: 0px
  }

  .step ::v-deep .el-step__icon-inner[class*=el-icon]:not(.is-status){
    font-size: 50px;
  }

  .step ::v-deep .el-step__title{
    margin-left: -30px;
  }

  .step ::v-deep .el-step__line{
    background-color:transparent
  }

  .step ::v-deep .el-step__line-inner{
    border-style : none ;
  }

</style>


